import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";

const api = new APIClient();

export const getAllAdminListService = (params = {}) => {
  return api.get(url.GET_ADMIN_LIST, params);
};

export const addAdminService = (params) => {
  return api.create(url.POST_ADMIN, params);
};

export const getAdminByIdService = (id) => {
  return api.get(url.GET_ADMIN(id));
};

export const deleteUserService = (id) => {
  return api.delete(url.DELETE_USER(id));
};

export const updateAdminStatusService = (id, startDate, expiryDate) => {
  return api.put(url.PUT_ADMIN_STATUS(id, startDate, expiryDate), {});
};
